import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";

export default function ProductCard({ product }) {
  const firstColor = product.colors?.[0];
  const mockup = product.mockups?.[firstColor]?.front;
  return (
    <Link to={`/product/${product.product_id}`} className="hb-card group block" data-testid={`product-card-${product.product_id}`}>
      <div className="relative aspect-[4/5] bg-[color:var(--hb-warm)] overflow-hidden">
        {mockup ? (
          <img src={fileUrl(mockup)} alt={product.name} className="hb-card-img w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="w-full h-full bg-neutral-200" />
        )}
        <div className="absolute top-3 left-3 text-[10px] tracking-widest uppercase bg-white/90 px-2 py-1">{product.apparel_name}</div>
      </div>
      <div className="mt-3 space-y-1">
        <div className="text-sm font-medium text-neutral-900">{product.name}</div>
        <div className="flex items-center gap-2">
          <div className="text-sm text-neutral-600">${product.base_price.toFixed(2)}</div>
          <div className="flex gap-1">
            {product.colors?.slice(0, 5).map(c => (
              <span key={c} className="w-3 h-3 rounded-full border border-neutral-300" style={{background: product.color_hex?.[c] || "#ccc"}} />
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}
